import { RemoteImage } from './strapi'

export type IntroSlideGratis = 'none' | 'sunglasses'

export type IntroSlide = {
  id: string | number
  title: string
  desc: string
  body: string
  image: RemoteImage
  gratis: IntroSlideGratis | null
  promoId: string | null
}
